import styled from 'styled-components';
import { baseVariables } from '../../styles';
import { OBannerSplitContentAlignment, OBannerSplitImageScale, OBannerSplitInset } from './OBannerSplit.types';

const getInsetPadding = (inset: OBannerSplitInset) => {
  switch (inset) {
    case 'L':
      return '3rem';
    case 'M':
      return '2rem';
    case 'S':
      return '1rem';
    case 'None':
    default:
      return '0';
  }
};

const getImageScale = (scale: OBannerSplitImageScale) => {
  switch (scale) {
    case 'L':
      return '60%';
    case 'M':
      return '50%';
    case 'S':
    default:
      return '40%';
  }
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;

  @media ${baseVariables.mediaQuery.md} {
    flex-direction: row;
    min-height: 600px;
  }

  @media ${baseVariables.mediaQuery.lg} {
    min-height: 700px;
  }
`;

export const MediaSection = styled.div<{ $imageScale: OBannerSplitImageScale; $order: number }>`
  position: relative;
  width: 100%;
  min-height: 400px;
  order: ${props => props.$order};

  @media ${baseVariables.mediaQuery.md} {
    width: ${props => getImageScale(props.$imageScale)};
    min-height: 100%;
  }

  & > * {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ContentSection = styled.div<{
  $inset: OBannerSplitInset;
  $alignment: OBannerSplitContentAlignment;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${props => (props.$alignment === 'Centered' ? 'center' : 'flex-start')};
  padding: 2rem 1rem;
  flex: 1;

  @media ${baseVariables.mediaQuery.md} {
    padding: ${props => getInsetPadding(props.$inset)};
    padding-inline: 2rem;
  }

  @media ${baseVariables.mediaQuery.lg} {
    padding: ${props => getInsetPadding(props.$inset)};
    padding-inline: 3rem;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 600px;
`;

export const TextBlockWrapper = styled.div`
  margin-bottom: 2rem;
`;

export const ButtonWrapper = styled.div<{ $alignment: OBannerSplitContentAlignment }>`
  display: flex;
  justify-content: ${props => (props.$alignment === 'Centered' ? 'center' : 'flex-start')};
`;
